import is from "./filter-set.js";
export default class ls {
  constructor(t, s) {
    (this.tf = t), (this.if = s), (this.tf = t), (this.if = s);
  }
  sf(t) {
    if (null == this.tf || null == this.if) return !1;
    const s = t[0],
      i = t[1];
    return s === this.tf && this.if.sf(i);
  }
  static fromJson(t) {
    return new ls(
      t ? t.event_name : null,
      t ? is.fromJson(t.property_filters) : null,
    );
  }
  gt() {
    return { e: this.tf, pf: this.if ? this.if.gt() : null };
  }
}
